export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 0a4.002 4.002 0 013.874 3H19v2h-3.126a4.005 4.005 0 01-1.75 2.388A6.002 6.002 0 0118 13v6a1 1 0 01-1 1h-2v1a3 3 0 11-6 0v-1H7a1 1 0 01-1-1v-6a6.002 6.002 0 013.875-5.612A4.006 4.006 0 018.126 5H5V3h3.126C8.57 1.275 10.136 0 12 0zm0 16a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1zm0-7a4 4 0 00-4 4v5h1v-1a3 3 0 116 0v1h1v-5a4 4 0 00-4-4zm0-7a2 2 0 100 4 2 2 0 000-4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};